export async function fetchJson<T>(input: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("accept", "application/json");

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<T>;
}

export async function fetchProtectedAsset(input: string, init: RequestInit = {}): Promise<Blob> {
  const headers = new Headers(init.headers);

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (!response.ok) {
    throw new Error(`Asset request failed: ${response.status} ${response.statusText}`);
  }

  return response.blob();
}